module.exports = __webpack_public_path__ + "static/media/empresa_login.a0e6fa08.png";